import { render, staticRenderFns } from "./ListeRecommendation.vue?vue&type=template&id=aa8a2680"
import script from "./ListeRecommendation.vue?vue&type=script&lang=js"
export * from "./ListeRecommendation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports